export default __webpack_public_path__ + "static/media/learner.e7f16215.svg";